import { ArrowUpRight, Download, ExternalLink, Link2 } from "lucide-react";
import { Link } from "react-router-dom";
import type { BrandAsset } from "../types";
import { CopyButton } from "./CopyButton";
import { LastUpdated } from "./LastUpdated";
import { StatusBadge } from "./StatusBadge";
import { AssetPreview } from "./AssetPreview";
import { requestTelegramFileDownload } from "../lib/telegram";

export function AssetCard({ asset }: { asset: BrandAsset }) {
  const available = !asset.placeholder && !asset.url.startsWith("#");
  const absoluteUrl = available ? new URL(asset.url, window.location.origin).href : "";
  const downloadsDirectly = asset.category === "logo";
  const downloadName = downloadsDirectly ? asset.url.split("/").pop() : undefined;

  return (
    <article className="asset-card">
      <AssetPreview asset={asset} />
      <div className="asset-card__content">
        <div className="asset-card__badges">
          <span className="file-type">{asset.fileType.toUpperCase()}</span>
          <StatusBadge status={asset.status} />
        </div>
        <h2>{asset.title}</h2>
        {asset.description && <p>{asset.description}</p>}
        <div className="asset-card__meta">
          {asset.version && <span>Версия: {asset.version}</span>}
          {asset.language && <span>Язык: {asset.language.toUpperCase()}</span>}
          <LastUpdated date={asset.updatedAt} />
        </div>
        {!available && <div className="placeholder-note">Ссылка на файл ещё не добавлена.</div>}
        <div className="card-actions">
          {available && (
            <>
              <a
                className="button button--primary"
                href={asset.url}
                target={downloadsDirectly ? undefined : "_blank"}
                rel={downloadsDirectly ? undefined : "noreferrer"}
                download={downloadName}
                onClick={downloadsDirectly
                  ? (event) => {
                      if (requestTelegramFileDownload(asset.url, downloadName ?? "social-logo.svg")) {
                        event.preventDefault();
                      }
                    }
                  : undefined}
              >
                {downloadsDirectly ? "Скачать" : "Открыть"}
                {downloadsDirectly
                  ? <Download size={17} aria-hidden="true" />
                  : <ExternalLink size={17} aria-hidden="true" />}
              </a>
              <CopyButton text={absoluteUrl} label="Скопировать ссылку" className="asset-card__copy" />
            </>
          )}
          <Link className="button button--ghost" to={`/assets/${asset.id}`}>
            Подробнее <ArrowUpRight size={17} aria-hidden="true" />
          </Link>
          {!available && <span className="sr-only"><Link2 size={16} />Ссылка отсутствует</span>}
        </div>
      </div>
    </article>
  );
}
